import { string } from "yup";
import getValue from "../../get-value/text";

const schema = string().email();

export default function(value) {
  const unwrapped = getValue(value);
  return !value || !unwrapped || schema.isValid(unwrapped.trim());
}
